import { lazy } from 'react';

export const NewsCalendarPageLazy = lazy(() => import('./news-calendar-page'));
